module.exports = __webpack_public_path__ + "static/media/icon-form-white.d00673f4.svg";